import React from "react";
import { Box, Spinner as ChakraSpinner } from "@chakra-ui/react";

const Spinner = () => {
    return (
        <Box
          position="fixed"
          top="0"
          left="0"
          width="100vw"
          height="100vh"
          display="flex"
          justifyContent="center"
          alignItems="center"
          backgroundColor="rgba(255, 255, 255, 0.8)" // Fondo blanco con opacidad
          zIndex="9999" // Asegurarte de que esté por encima de todo
        >
          <ChakraSpinner size="xl" thickness="4px" color="blue.500" />
        </Box>
      );
    }

export default Spinner;